import { downloadFile } from 'src/app/utils/pdf-downloader';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { sweetAlert } from 'src/app/utils/swal';
import { Observable, from, Subscription } from "rxjs";
import { exportToCsv, exportToExcel, getBrokersList } from '../../../utils/utils.common';
import { getBrokerImage } from '../../../utils/utils.common';
import { downloadBase64File } from '../../../utils/pdf-downloader';
import { reduce, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { KpisService } from '../kpis-service/kpis.service';
import { data } from 'jquery';
import * as moment from 'moment';

@Component({
  selector: 'app-nemt-report-revenue',
  templateUrl: './nemt-report-revenue.component.html',
  styleUrls: ['./nemt-report-revenue.component.css']
})
export class NemtReportRevenueComponent implements OnInit {
  getKpisState: Observable<any>;
  assignedKpis;
  brokerKpis = [];
  corporateKpis = [];
  driverKpis = [];
  nobrokerTrips = 0;
  noCorporateTrips;
  dateForm: UntypedFormGroup;
  isVisible = true; // for table coloumns
  drivers = [];
  fundingSources = [];
  totalJobs: any;
  totalCancelledTrips: any;
  totalCompletedTrips: any;
  revenueKpis:any = {};
  constructor(private fb: UntypedFormBuilder, private kpisService: KpisService) {
  }


  ngOnInit() {
     this.dateForm = this.fb.group({
          dateRange: [[moment().startOf('day').toISOString(), moment().endOf('day').toISOString()]]
        });
  }

    getNemtReports() {
      this.kpisService.getNemtReports()
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            console.log('data', data);
            this.fundingSources = data.cooperateKpis;
            this.drivers = data.driverKpis;
            this.revenueKpis = data.revenueKpis[0]

            if (this.fundingSources) {

              this.totalJobs = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalJobs
              }, 0);
              console.log('totalJobs', this.totalJobs);
              this.totalCancelledTrips = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalCancelledJobs
              }, 0);
              console.log('totalCancelledTrips', this.totalCancelledTrips);
              this.totalCompletedTrips = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalCompletedJobs
              }, 0);
              console.log('totalCompletedTrips', this.totalCompletedTrips);
            }
          }
        })
      // this.store.dispatch(new NemtReports());
    }

    getNemtStatsByDateRange() {
      const startDate = this.dateForm.value.dateRange[0].startOf('day').toISOString();
      const endDate = this.dateForm.value.dateRange[1].endOf('day').toISOString();
      this.kpisService
        .getNemtReportsByDate(startDate, endDate)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.fundingSources = data.cooperateKpis;
            this.drivers = data.driverKpis;
            this.revenueKpis = data.revenueKpis[0]

            if (this.fundingSources) {

              this.totalJobs = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalJobs
              }, 0)
              console.log('totalJobs', this.totalJobs);

              this.totalCancelledTrips = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalCancelledJobs
              }, 0)
              console.log('totalCancelledTrips', this.totalCancelledTrips);

              this.totalCompletedTrips = this.fundingSources.reduce((acc, item) => {
                return acc + item.totalCompletedJobs
              }, 0)
              console.log('totalCompletedTrips', this.totalCompletedTrips);
            }

          }
        })

    }

  getBrokerName(brokerName) {
    if (brokerName.length === 0) {
      brokerName = 'default';
    }
    return getBrokersList[brokerName];
  }
  getBrokerImg(brokerName) {
    return getBrokerImage(brokerName);
  }

  onToggleClicked() {
    this.isVisible = !this.isVisible;
  }

  // downloadBusinessReport() {
  //   const payload = {
  //     endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
  //     startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null,
  //     type: 'kpis'
  //   };
  //   this.kpisService
  //     .getNemtBusinessReportPdf(payload)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       downloadBase64File(data.content, data.pdfName);
  //     })

  // }

  downloadMilesReport() {
    const payload = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null,
      type: 'miles'
    };
    this.kpisService
      .getNemtBusinessReportPdf(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        downloadBase64File(data.content, data.pdfName);
      })

  }

  downloadBrokerReport() {
    const data = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null
    };
    this.kpisService
      .getNemtBrokerReportPdf(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);

        }
      })
    // this.store.dispatch(new NemtBrokerReportPdf(data));
  }

  // downloadCorporateReport() {
  //   const data = {
  //     endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
  //     startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null
  //   };
  //   this.kpisService
  //     .getNemtCorporateReportPdf(data)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         downloadBase64File(data.content, data.pdfName);
  //       }
  //     })
  //   // this.store.dispatch(new NemtCorporateReportPdf(data));
  // }

  downloadCorporateTripReport(corporateId) {
    const data = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null
    };
    this.kpisService
      .getNemtCorporateTripReportPdf(data, corporateId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      })
    // this.store.dispatch(new NemtCorporateTripReportPdf(data, corporateId));
  }

  downloadDriverReport() {
    const data = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null
    };
    this.kpisService
      .getNemtDriverReportPdf(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      })
    // this.store.dispatch(new NemtDriverReportPdf(data));
  }

  gmtKpiReport() {
    const payload = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null,
    };
    // DownloadFile.downloadURI(name, url);
    this.kpisService
      .getNemtGMTKpiReportPdf(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        downloadBase64File(data.content, data.pdfName);
      })
    // catchError((error) => {
    //     return of(new CommonFailure({ type: KpisActionTypes.NEMT_BUSSINESS_REPORT_PDF, error }));
    // })
  }

  driverkpiReport(driverId) {
    const payload = {
      endDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[1].endOf('day').toISOString() : null,
      startDate: this.dateForm.value.dateRange ? this.dateForm.value.dateRange[0].startOf('day').toISOString() : null,
      driverId: driverId
    };
    // DownloadFile.downloadURI(name, url);
    this.kpisService
      .getNemtDriverKpiReportPdf(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        downloadBase64File(data.content, data.pdfName);
      })
    // catchError((error) => {
    //     return of(new CommonFailure({ type: KpisActionTypes.NEMT_BUSSINESS_REPORT_PDF, error }));
    // })
  }

  driverBusinessReoprt() {
    const table = [
      [
        "Driver Name",
        "Total Trips.",
        "Cancelled Trips",
        "Completed Trips"
      ]
    ];

    this.drivers.forEach((item) => {
      const stats = [
        item.driver.displayName,
        item.totalJobs,
        item.totalCancelledJobs,
        item.totalCompletedJobs
      ]
      table.push(stats);
    })



    exportToCsv(`Driver-Trips_Reports.csv`, table);
  }

  downloadFSReport() {
    const table = [
      [
        "Funding Source",
        "Total Trips.",
        "Pending Trips",
        "InProgress Trips",
        "Cancelled Trips",
        "Completed Trips"
      ]
    ];

    this.fundingSources.forEach((item) => {
      const stats = [
        item.cooperate.displayName,
        item.totalJobs,
        item.totalRemainingJobs,
        item.totalActiveJobs,
        item.totalCancelledJobs,
        item.totalCompletedJobs
      ]
      table.push(stats);
    })

    exportToCsv(`Funding_Source_Reports.csv`, table);
  }

  downloadBusinessReport() {

    const sheet1 = [
      [
        "Total Trips.",
        "Cancelled Trips",
        "Completed Trips"
      ]
    ]

    let stats = [
      this.totalJobs,
      this.totalCancelledTrips,
      this.totalCompletedTrips

    ]
    sheet1.push(stats)

    // fundingSourcesData

    const sheet2 = [
      [
        "Funding Source",
        "Total Trips.",
        "Pending Trips",
        "InProgress Trips",
        "Cancelled Trips",
        "Completed Trips",
        "Miles"
      ]
    ]

    let fundingSourcesData

    this.fundingSources.forEach(item => {
      fundingSourcesData = [
        item.cooperate.displayName,
        item.totalJobs,
        item.totalRemainingJobs,
        item.totalActiveJobs,
        item.totalCancelledJobs,
        item.totalCompletedJobs,
        item.totalMiles
      ]
      sheet2.push(fundingSourcesData);

    });


    const sheet3 = [
      [
        "Driver Name",
        "Total Trips.",
        "Cancelled Trips",
        "Completed Trips"
      ],
    ]

    let driverData
    this.drivers.forEach((item) => {
      driverData = [
        item.driver.displayName,
        item.totalJobs,
        item.totalCancelledJobs,
        item.totalCompletedJobs
      ]
      sheet3.push(driverData);
    })

    const sheets = {
      "Stats": sheet1,
      "Funding Sources": sheet2,
      "Drivers": sheet3,
    };
    exportToExcel("BusinessReport.xlsx", sheets);
  }


  ngOnDestroy(): void {
  }

}
